<div class="h-dvh flex flex-col gap-5 items-center justify-center overflow-hidden p-5 text-center text-on-background">
    <mat-icon class="size-16! sm:size-20!" [svgIcon]="ICON.warningTriangle" />
    <h1
        class="text-display-sm sm:text-display-lg leading-display-sm sm:leading-display-lg tracking-display-sm sm:tracking-display-lg">
        {{ 'Error.Not Found.Title' | translate }}
    </h1>
    <p class="sm:text-body-lg sm:leading-body-lg sm:tracking-body-lg opacity-80">
        {{ 'Error.Not Found.Description' | translate }}
    </p>
    <a class="underline" [routerLink]="[dashboardUrl]">
        {{ 'Error.Not Found.Back to Dashboard' | translate }}
    </a>
</div>